import React, { Component } from 'react';
import Firebase from 'firebase';
import { browserHistory } from 'react-router'
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);


const dev = "AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384";
const prox = "AIzaSyANYvWuAeGYm78Q2hKqJsxGhnnHrFYczos";

class addUser extends Component {
    constructor() {
        super();
        this.state = {
            user_id: "",
            name: "",
            rut: "",
            email: "",
            created_at: "",
            modified_at: "",
            password: "",
            spinner: true
        }
        this.setFirebase = this.setFirebase.bind(this);
        this.renderButton = this.renderButton.bind(this);
    }

    componentWillMount() {
        var newUserKey = Firebase.database().ref().child('users').push().key;
        this.setState({ user_id: newUserKey, token: JSON.parse(localStorage["firebase:authUser:AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384:[DEFAULT]"]).stsTokenManager.accessToken });
    }

    setFirebase() {
        const urlprox = 'https://us-central1-operatio-a399c.cloudfunctions.net/api/admin/createUser';
        const urldev = 'https://us-central1-operatio-pro-dev-493b8.cloudfunctions.net/api/admin/createUser';
        
        const data = {
            isAdmin: false,
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            rut: this.state.rut,
            client_id: localStorage.client_id
        };

        fetch(urldev, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.state.token
            }
        })
            .then((response) => {
                switch (response.status) {
                    case 403:
                        this.refs.container.warning(
                            "USUARIO NO FUE CREADO",
                            "verifique que el email no este registrado o que esté bien escrito", {
                                timeOut: 3000,
                                extendedTimeOut: 10000
                            });
                        this.setState({ spinner: true })
                        break;
                    case 201:
                        return response.json();
                    default:
                        break;
                }
            })
            .then(jsonResponse => {
                if (jsonResponse !== undefined) {
                    var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                    var id = Firebase.database().ref().child('log').push().key;
                    logRef.child(id).set({
                        admin: localStorage.email,
                        timestamp: Firebase.database.ServerValue.TIMESTAMP,
                        action: "add",
                        target: {
                            type: "user",
                            name: this.state.name
                        }
                    });
                    this.props.callBack(this.state.name);
                }
            })
            .catch(error => {
            });

    }

    renderButton() {
        if (this.state.rut && this.state.name && this.state.email && this.state.password) {
            return (
                <div>
                    {
                        this.state.spinner
                            ?
                            <a className="btn btn-success" onClick={() => { this.setFirebase(); this.setState({ spinner: false }) }} >Crear usuario</a>
                            :
                            <a className="btn btn-success"><i className="fa fa-refresh fa-spin"></i> Enviando datos...</a>
                    }
                </div>

            )
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <ToastContainer ref="container"
                        style={{ top: "60px" }}
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right"
                    />
                    <div className="col-sm-12">
                        <div className="form-group">
                            <div className="form-group">
                                <label htmlFor="name">Rut</label>
                                <input type="text" className="form-control" id="rut" placeholder="Rut del usuario"
                                    value={this.state.rut}
                                    onChange={(e) => { this.setState({ rut: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Nombre</label>
                                <input type="text" className="form-control" id="inputName" placeholder="Nombre del usuario"
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Email</label>
                                <input type="text" className="form-control" id="inputEmail"
                                    placeholder="Email del usuario"
                                    value={this.state.email}
                                    onChange={(e) => { this.setState({ email: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Contraseña</label>
                                <input type="text" className="form-control" id="inputEmail"
                                    placeholder="Contraseña para el usuario"
                                    value={this.state.password}
                                    onChange={(e) => { this.setState({ password: e.target.value }) }} />
                            </div>
                            <div className="form-group">
                                <div className="col-lg-10 text-right">
                                    {
                                        this.renderButton()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default addUser;



// WEBPACK FOOTER //
// ./src/views/users/addUser.js